module.exports = __webpack_public_path__ + "img/lex-libris-logo.b233d3a2.svg";